import React, { useRef, useContext, useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify'; // Importation
import getBaseUrl from '../helpers/utility';
import '../App.css'
const EditPersonnel = () => {
  const navigate = useNavigate();
  const baseUrl = getBaseUrl();

  const { id } = useParams();
  let token = localStorage.getItem('accessToken');

  const [personnel, setPersonnel] = useState({
    nomprenom: '',
    sexe: '',
    cin: '',
    datenaisse: '',
    fonction: '',
    etsouserviceId: '',
    gradeId: '',
    compagnieId: '',
    adresseMail: '',
    delivrele: '',
    telephone: '',
    whatsapp: '',
    situationmatrimoniale: '',
    nomConjoint: '',
    a: '',
    adresseactuelle: '',
    afficheImage: '',
    observation: '',
    datemariage: '',
    dateNaissConj: '',
    lieuNaissConj: '',
    groupesanguin: '',
    groupeethnique: '',
    religion: '',
    lieu: '',
    affectionactuelle: '',
    matricule: '',
    daterecrute: '',
    indice: '',
    interruptiondu: '',
    au: '',
    sortantecole: '',
    bureautique: false,
    autres: '',
    francais: '',
    anglais: '',
    autresLangue: '',
    NumPermis: '',
    permisDelivrele: '',
    lieuDelivrance: '',
    permisCategorie: '',
    autresPermis: '',
    MatriculeFinance: '',
    des: '',
    annee: '',
    vague: '',
    dn: '',
    cim: '',
    nomdupere: '',
    nomdelamere: '',
    campagne: '',
    punition: '',
    affectationTemporaire: '',
    affectationDedinitive: '',
    prenomsUsuel: '',
    direction: '',
    typePers: '',
    diplomeadministratif: '',
    arme: '',
    positionexacte: '',
    situation: '',
    eleves: '',
    situationactuelle: '',
    interieur: '',
    file: null,
    valider: false,
  });

  const [listEtsouservice, setListEtsouservice] = useState([]);
  const [listGrade, setListGrade] = useState([]);
  //const [listeCompagnie, setListCompagnie] = useState([])
  const [boaDss, setBoaDss] = useState([]);

  const [brigade, setBrigade] = useState([]);
  const [bataillon, setBataillon] = useState([]);
  const [compagnie, setCompagnie] = useState([]);

  const [selectBrigade, setSelectBrigade] = useState([]);
  const [selectBataillon, setSelectBataillon] = useState([]);

  const [affectations, setAffectations] = useState([{ lieuaffect: '', fonctiontenue: '', dateeffet: '' }]);
  const [enfants, setEnfants] = useState([{ nomprenom: '', datenaisse: '', sexe: '', observation: '' }]);
  const [ecole, setEcole] = useState([{ intitule: '', etablissement: '', diplome: '', annee: '' }]);
  const [operations, setOperations] = useState([
    {
      corpsunites: '',
      bataillonoudss: '',
      observation: '',
      boadssId: '',
      dateDebut: '',
      dateFin: '',
    },
  ]);

  const [promotiongrade, setPromotiongrade] = useState([{ portgrade: '', datepromotion: '', gradeId: '' }]);
  const [avancements, setAvancements] = useState([{ statu: '', reference: '', dateeffet: '' }]);

  const [decorations, setDecoration] = useState([]);
  const [listeDecoration, setListeDecoration] = useState([{ decretouarrete: '', dateObtention: '', decorationId: '' }]);

  const [newImage, setNewImage] = useState(null); // Pour gérer la nouvelle image sélectionnée
  const [removeImage, setRemoveImage] = useState(false); // Pour gérer la suppression de l'image existante
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleRemoveImage = () => {
    setPersonnel({ ...personnel, filename: '' });
    setRemoveImage(true); // Indiquer que l'image existante doit être supprimée
  };

  const handleImageChange = (e) => {
    setNewImage(e.target.files[0]);
    setRemoveImage(false); // Réinitialiser l'état de suppression si une nouvelle image est sélectionnée
  };

  useEffect(() => {
    const fetchPersonnels = async () => {
      try {

        const response = await axios.get(`personnel/show/${id}`);
        const personnelData = response.data;
        setPersonnel(personnelData);
        setEnfants(response.data.enfant || []);
        setAffectations(response.data.affectations || []);
        setEcole(personnelData.ecole || []);
        setAvancements(personnelData.avancement || []);
        setPromotiongrade(personnelData.gradesuccessifs || []);
        setOperations(personnelData.operationnels || []);
        setListeDecoration(
          personnelData.decorations.map((deco) => ({
            decretouarrete: deco.PersonnelDecoration.decretouarrete || '',
            dateObtention: deco.PersonnelDecoration.dateObtention || '',
            decorationId: deco.id || '',
          }))
        );

        if (personnelData.compagnie) {
          setSelectBrigade(personnelData.compagnie.bataillon.brigade.id);
          setSelectBataillon(personnelData.compagnie.bataillon.id);
        }
      } catch (error) {
        toast.error(error.response?.data?.error);
      }
    };
    fetchPersonnels();
  }, [id]);

  useEffect(() => {
    axios.get('/etsouservice').then((res) => {
      setListEtsouservice(res.data);
    });

    axios.get('/grade').then((res) => {
      setListGrade(res.data);
    });

    axios.get('/brigade').then((res) => {
      setBrigade(res.data);
    });

    axios.get('/bataillon').then((res) => {
      setBataillon(res.data);
    });
    axios.get('/decoration').then((res) => {
      setDecoration(res.data);
    });
    axios.get('/boadss').then((response) => {
      setBoaDss(response.data);
    });
  }, []);

  useEffect(() => {
    if (selectBrigade) {
      axios.get(`bataillon/${selectBrigade}`).then((res) => setBataillon(res.data));
    }
  }, [selectBrigade]);

  useEffect(() => {
    if (selectBataillon) {
      axios.get(`compagnie/${selectBataillon}`).then((res) => setCompagnie(res.data.compagnie));
    }
  }, [selectBataillon]);

  /* const handleChange = (e) => {
    const name = e.target.name;
    const type = e.target.type;
    let value;
    if (type === 'checkbox') {
      value = e.target.checked;
    } else if (type === 'text') {
      value = e.target.value;
    } else if (type === 'date') {
      value = e.target.value;
    } else if (type === 'select-one') {
      value = e.target.value;
    }

    setPersonnel({ ...personnel, [name]: value });
  }; */
  const handleChange = (e) => {
    const name = e.target.name;
    const type = e.target.type;
    let value;

    if (type === 'checkbox') {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }

    // 🔹 Cas spécial : changement de l’Armé
    if (name === 'arme') {
      setPersonnel({
        ...personnel,
        arme: value,
        gradeId: '', // reset du grade
      });
    } else {
      setPersonnel({
        ...personnel,
        [name]: value,
      });
    }
  };
  const handleAddAffectation = () => {
    setAffectations([
      ...affectations,
      {
        lieuaffect: '',
        fonctiontenue: '',
        dateeffet: '',
        decisionaffectation: '',
      },
    ]);
  };
  const handleRemoveAffectation = (index) => {
    const newAffectations = affectations.filter((_, i) => i !== index);
    setAffectations(newAffectations);
  };
  const handleAddAffectationChange = (index, e) => {
    const { name, value } = e.target;
    const newAffectation = affectations.map((affectation, i) => {
      if (i === index) {
        return { ...affectation, [name]: value };
      }
      return affectation;
    });
    setAffectations(newAffectation);
  };

  const handleAddEnfant = () => {
    setEnfants([...enfants, { nomprenom: '', datenaisse: '', sexe: '', observation: '' }]);
  };
  const handleRemoveEnfant = (index) => {
    const newEnfant = enfants.filter((_, i) => i !== index);
    setEnfants(newEnfant);
  };
  const handleAddEnfantChange = (index, e) => {
    const { name, value } = e.target;
    const newEnfant = enfants.map((enfant, i) => {
      if (i === index) {
        return { ...enfant, [name]: value };
      }
      return enfant;
    });
    setEnfants(newEnfant);
  };

  const handleAddEcole = () => {
    setEcole([...ecole, { intitule: '', etablissement: '', diplome: '', annee: '' }]);
  };
  const handleRemoveEcole = (index) => {
    const newEcole = ecole.filter((_, i) => i !== index);
    setEcole(newEcole);
  };
  const handleAddEcoleChange = (index, e) => {
    const { name, value } = e.target;
    const newEcole = ecole.map((ecole, i) => {
      if (i === index) {
        return { ...ecole, [name]: value };
      }
      return ecole;
    });
    setEcole(newEcole);
  };

  const handleAddAvancement = () => {
    setAvancements([...avancements, { statu: '', reference: '', dateeffet: '' }]);
  };
  const handleRemoveAvancement = (index) => {
    const newAvancement = avancements.filter((_, i) => i !== index);
    setAvancements(newAvancement);
  };
  const handleAddAvancementChange = (index, e) => {
    const { name, value } = e.target;
    const newAvancement = avancements.map((avancement, i) => {
      if (i === index) {
        return { ...avancement, [name]: value };
      }
      return avancement;
    });
    setAvancements(newAvancement);
  };

  const handleAddPromotionGrade = () => {
    setPromotiongrade([...promotiongrade, { portgrade: '', datepromotion: '', gradeId: '' }]);
  };
  const handleRemovePromotionGrade = (index) => {
    const newPromotionGrade = promotiongrade.filter((_, i) => i !== index);
    setPromotiongrade(newPromotionGrade);
  };
  const handleAddPromotionGradeChange = (index, e) => {
    const { name, value } = e.target;
    const newPromotion = promotiongrade.map((promotiongrade, i) => {
      if (i === index) {
        return { ...promotiongrade, [name]: value };
      }
      return promotiongrade;
    });
    setPromotiongrade(newPromotion);
  };

  // Ajouter une nouvelle opération
  const handleAddOperation = () => {
    setOperations([
      ...operations,
      {
        corpsunites: '',
        bataillonoudss: '',
        observation: '',
        boadssId: '',
        dateDebut: '',
        dateFin: '',
      },
    ]);
  };

  // Supprimer une opération existante
  const handleRemoveOperation = (index) => {
    const newOperations = operations.filter((_, i) => i !== index);
    setOperations(newOperations);
  };

  // Gérer le changement dans un champ d'opération
  const handleAddOperationChange = (index, e) => {
    const { name, value } = e.target;
    const newOperations = operations.map((operation, i) => {
      if (i === index) {
        return { ...operation, [name]: value };
      }
      return operation;
    });
    setOperations(newOperations);
  };

  const handleAddDecoration = () => {
    setListeDecoration([...listeDecoration, { decretouarrete: '', dateObtention: '', decorationId: '' }]);
  };
  const handleRemoveDecoration = (index) => {
    const newDecoration = listeDecoration.filter((_, i) => i !== index);
    setListeDecoration(newDecoration);
  };

  const handleAddDecorationChange = (index, e) => {
    const { name, value } = e.target;
    const newDecoration = listeDecoration.map((deco, i) => {
      if (i === index) {
        return { ...deco, [name]: value };
      }
      return deco;
    });
    setListeDecoration(newDecoration);
    //   console.log(newDecoration);
  };

  const checkboxRef = useRef(null);

  const enregistrer = async (e) => {
    e.preventDefault();
    if (!personnel['valider']) {
      toast.warn('Veuillez valider votre enregistrement', {
        position: 'bottom-right',
      });
      checkboxRef.current.focus();
      return;
    }
    const data = new FormData();

    data.append('enfants', JSON.stringify(enfants));
    data.append('affect', JSON.stringify(affectations));
    data.append('ecoles', JSON.stringify(ecole));
    data.append('avancements', JSON.stringify(avancements));
    data.append('deco', JSON.stringify(listeDecoration));
    data.append('operationnels', JSON.stringify(operations));
    data.append('promotiongrade', JSON.stringify(promotiongrade));
    data.append('personnelData', JSON.stringify(personnel));

    if (newImage) {
      // Fixer le nom de l'image par nomprenom + nom de l'image sélectionnée
      const fixedImageName = `${personnel.nomprenom}_${newImage.name}`;
      data.append('file', newImage, fixedImageName);
    } else if (removeImage) {
      // Si l'utilisateur a supprimé l'image existante
      data.append('removeImage', true);
    } else {
      // Garder l'image existante si aucune modification
      data.append('filename', personnel.filename);
    }

    try {
      const response = await axios.put(`personnel/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate('/personnel');
        }, 2000);
      }
    } catch (error) {
      toast.error(error.response.data.error);
    }
  };

  const getGradeLabel = (grade) => {
    if (personnel.arme === 'TERRE') return grade.name;
    if (personnel.arme === 'AIR') return grade.gradeair;
    if (personnel.arme === 'MER') return grade.grademer;
    return '';
  };

  return (
    <div className="container mt-3  border ">
      <div className="">
        <div className="col bg-warning rounded " style={{ borderWidth: '5px' }} >
          <h3>Modification d'un enregistrement</h3>
        </div>
      </div>
      {/* initialValues={initialValues} validationSchema={validation} */}
      <form onSubmit={enregistrer}>
        <fieldset className="border border-warning custom-fieldset rounded  " style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary ">
            BRCA
          </legend>
          <div className=" row mb-3 ml-3 mr-3">
            <div className=" col-md-2  ">
              <label htmlFor="arme">Armé de : </label>
              <select value={personnel.arme} onChange={handleChange} id="arme" name="arme" className="form-control" required >
                <option value=""></option>
                <option value="TERRE">TERRE</option>
                <option value="MER">MER</option>
                <option value="AIR">AIR</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="brigade">Brigade : </label>
              <select value={selectBrigade} onChange={(e) => setSelectBrigade(e.target.value)} id="brigade" name="brigade" className="form-control">
                <option value=""></option>
                {brigade.map((brigade, key) => {
                  return (
                    <option key={key} value={brigade.id}>
                      {brigade.name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className=" col">
              <label htmlFor="bataillon">Bataillon :</label>
              <select value={selectBataillon || ''} onChange={(e) => setSelectBataillon(e.target.value)} id="bataillon" className="form-control">
              // Désactiver si aucune brigade sélectionnée
                <option value="">Choisir un Bataillon</option>
                {bataillon.map((bataillon) => (
                  <option key={bataillon.id} value={bataillon.id}>
                    {bataillon.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col">
              <label htmlFor="compagnie">Compagnie : </label>
              <select value={personnel.compagnieId} onChange={handleChange} id="compagnieId" name="compagnieId" className="form-control">
                <option value=""></option>
                {compagnie.map((compagnie, key) => {
                  return (
                    <option key={key} value={compagnie.id}>
                      {compagnie.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </fieldset>

        <fieldset className="border border-warning custom-fieldset custom-fieldset rounded  "  >
          <legend className="w-auto px-4 text-primary ">
            Identité
          </legend>
          <div className='row mb-3 ml-3 mr-3' >
            <div className='col' >
              <div className="row ">
                <div className="col">
                  <label htmlFor="nomprenom">Nom et prénoms : </label>
                  <input type="text" name="nomprenom" placeholder="nom et prénoms" value={personnel.nomprenom} onChange={handleChange} className="form-control" required />
                </div>
                <div className="col-md-2">
                  <label htmlFor="grade">Grade :</label>
                  {/* désactivé tant que Armé de n’est pas choisi */}
                  <select value={personnel.gradeId} onChange={handleChange} id="gradeId" name="gradeId" className="form-control" required disabled={!personnel.arme}>
                    <option value="">
                      {personnel.arme ? 'Choisir un grade' : 'Choisir d’abord l’Armé'}
                    </option>

                    {listGrade.map((grade) => (
                      <option key={grade.id} value={grade.id}>
                        {getGradeLabel(grade)}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col">
                  <label htmlFor="fonction">Fonction : </label>
                  <input value={personnel.fonction} onChange={handleChange} id="fonction" name="fonction" className="form-control  " type="text" />
                </div>

              </div>
              <div className='row' >
                <div className="col-md-2">
                  <label htmlFor="etsouservice">Ets. ou Service : </label>
                  <select value={personnel.etsouserviceId} onChange={handleChange} id="etsouserviceId" name="etsouserviceId" className="form-control">
                    {/* multiple="multiple" */}
                    <option value=""></option>
                    {listEtsouservice.map((etsouservice, key) => {
                      return (
                        <option key={key} value={etsouservice.id}>
                          {etsouservice.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col">
                  <label htmlFor="sexe">Sexe :</label>
                  <select value={personnel.sexe} className="form-control" onChange={handleChange} id="sexe" name="sexe">
                    <option value={personnel.sexe}>{personnel.sexe}</option>
                    <option value="H">H</option>
                    <option value="F">F</option>
                  </select>
                </div>
                <div className="col">
                  <label htmlFor="datenaisse">Date de naissance : </label>
                  <input value={personnel.datenaisse} type="date" onChange={handleChange} id="datenaisse" name="datenaisse" className="form-control" />
                </div>
                <div className="col">
                  <label htmlFor="lieu">Lieu de naissance : </label>
                  <input value={personnel.lieu} className="form-control" type="text" name="lieu" id="lieu" onChange={handleChange} />
                </div>
                <div className="col-md-2">
                  <label htmlFor="indice">Indice : </label>
                  <input value={personnel.indice} className="form-control" type="text" name="indice" id="indice" onChange={handleChange} />
                </div>
              </div>
              <div className='row' >
                <div className="col">
                  <label htmlFor="daterecrute">Date d'entré en service : </label>
                  <input value={personnel.daterecrute} className="form-control" type="date" name="daterecrute" id="daterecrute" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="cin">CIN :</label>
                  <input value={personnel.cin} type="text" onChange={handleChange} id="cin" name="cin" className="  form-control" />
                </div>

                <div className="col">
                  <label htmlFor="delivrele">Délivré le : </label>
                  <input value={personnel.delivrele} className="form-control  " type="date" name="delivrele" id="delivrele" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="a">à : </label>
                  <input value={personnel.a} className="form-control" type="text" name="a" id="a" onChange={handleChange} />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <label htmlFor="matricule">Matricule : </label>
                  <input value={personnel.matricule} className="form-control " type="text" name="matricule" id="matricule" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="telephone">Téléphone : </label>
                  <input value={personnel.telephone} className="form-control " type="text" name="telephone" id="telephone" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="whatsapp">Whatsapp : </label>
                  <input value={personnel.whatsapp} className="form-control" type="text" name="whatsapp" id="whatsapp" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="adresseMail">E-Mail : </label>
                  <input value={personnel.adresseMail} className="form-control" type="text" name="adresseMail" id="adresseMail" onChange={handleChange} />
                </div>
              </div>
              <div className="row">
                {/*           <div className="col">
            <label htmlFor="groupesanguin">Groupe sanguin : </label>
            <input value={personnel.groupesanguin} className="form-control" type="text" name="groupesanguin" id="groupesanguin" onChange={handleChange} />
          </div>
          <div className="col">
            <label htmlFor="groupeethnique">Groupe Ethnique : </label>
            <input value={personnel.groupeethnique} className="form-control" type="text" name="groupeethnique" id="groupeethnique" onChange={handleChange} />
          </div>
          <div className="col">
            <label htmlFor="religion">Religion : </label>
            <input value={personnel.religion} className="form-control" type="text" name="religion" id="religion" onChange={handleChange} />
          </div> */}
              </div>
              <div className="row">
                <div className="col">
                  <label htmlFor="direction">Direction : </label>
                  <select onChange={handleChange} value={personnel.direction} name="direction" id="direction" className="form-control" required>
                    <option value={personnel.direction}>{personnel.direction}</option>
                    <option value="DCCA">DCCA</option>
                    <option value="Autres">Autres</option>
                  </select>
                </div>

                <div className="col">
                  <label htmlFor="adresseactuelle">Adresse :</label>
                  <input value={personnel.adresseactuelle} type="text" onChange={handleChange} id="adresseactuelle" name="adresseactuelle" className="form-control" />
                </div>
                <div className="col">
                  <label htmlFor="nomdupere">Nom du père : </label>
                  <input value={personnel.nomdupere} className="form-control" type="text" name="nomdupere" id="nomdupere" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="nomdelamere">Nom de la mère : </label>
                  <input value={personnel.nomdelamere} className="form-control" type="text" name="nomdelamere" id="nomdelamere" onChange={handleChange} />
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="border border-warning custom-fieldset border-3 rounded  " style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary ">
            Epoux(se)
          </legend>
          <div className="row mb-3 ml-3 mr-3">
            <div className="col">
              <label htmlFor="situationmatrimoniale">Situation matrimoniale :</label>
              <select onChange={handleChange} value={personnel.situationmatrimoniale} name="situationmatrimoniale" id="situationmatrimoniale" className="form-control  " required>
                <option value={personnel.situationmatrimoniale}>{personnel.situationmatrimoniale}</option>
                <option value="MARIE">MARIE</option>
                <option value="DIVORCE">DIVORCE</option>
                <option value="CELIBATAIRE">CELIBATAIRE</option>
                <option value="VEUF">VEUF</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="nomConjoint">Nom et prénoms : </label>
              <input value={personnel.nomConjoint} className="form-control" type="text" name="nomConjoint" id="nomConjoint" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="datemariage">Date mariage : </label>
              <input value={personnel.datemariage} className="form-control" type="date" name="datemariage" id="datemariage" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="dateNaissConj">Date de naissance :</label>
              <input value={personnel.dateNaissConj} className="form-control" type="date" name="dateNaissConj" id="dateNaissConj" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="lieuNaissConj">lieu de naissance : </label>
              <input value={personnel.lieuNaissConj} className="form-control" type="text" name="lieuNaissConj" id="lieuNaissConj" onChange={handleChange} />
            </div>
          </div>
        </fieldset>

        <fieldset className="border border-warning custom-fieldset border-3 rounded  " style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary ">
            Connaissances en Informatique
          </legend>
          <div className="row mb-3 ml-3 mr-3">
            <div className="col">
              <div className="form-check form-check-lg">
                <input
                  type="checkbox"
                  name="bureautique"
                  id="bureautique"
                  checked={personnel.bureautique}
                  onChange={handleChange}
                  style={{ transform: 'scale(1.6)', cursor: 'pointer' }}
                />

                <label className="form-check-label ml-2" htmlFor="bureautique">
                  Bureautique ?
                </label>
              </div>
            </div>


            <div className="col">
              <label htmlFor="autres">Autres connaissance en INFO : </label>
              <input value={personnel.autres} className="form-control" type="text" name="autres" id="autres" onChange={handleChange} />
            </div>
          </div>
        </fieldset>

        <fieldset className="border border-warning custom-fieldset border-3 rounded  " style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary ">
            Connaissances linguistiques
          </legend>
          <div className="row mb-3 ml-3 mr-3">
            <div className="col">
              <label htmlFor="francais">Français</label>
              <select value={personnel.francais} onChange={handleChange} id="francais" name="francais" className="form-control">
                <option value=""></option>
                <option value="Débutant">Débutant</option>
                <option value="Moyen">Moyen</option>
                <option value="Avancé">Avancé</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="anglais">Anglais</label>
              <select value={personnel.anglais} onChange={handleChange} id="anglais" name="anglais" className="form-control">
                <option value=""></option>
                <option value="Débutant">Débutant</option>
                <option value="Moyen">Moyen</option>
                <option value="Avancé">Avancé</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="autresLangue">Autres langues : </label>
              <input value={personnel.autresLangue} className="form-control" type="text" name="autresLangue" id="autresLangue" onChange={handleChange} />
            </div>

          </div>
        </fieldset>

        <fieldset className="border border-warning custom-fieldset border-3 rounded  " style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary ">
            Aptitudes particuliers
          </legend>
          <div className="row mb-3 ml-3 mr-3">
            <div className="col">
              <label htmlFor="NumPermis"> Numéro Permis : </label>
              <input value={personnel.NumPermis} className="form-control" type="text" name="NumPermis" id="NumPermis" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="permisDelivrele">Permis Délivré le : </label>
              <input value={personnel.permisDelivrele} className="form-control" type="date" name="permisDelivrele" id="permisDelivrele" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="lieuDelivrance">lieu de délivrance : </label>
              <input value={personnel.lieuDelivrance} className="form-control" type="text" name="lieuDelivrance" id="lieuDelivrance" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="permisCategorie">Categorie : </label>
              <input value={personnel.permisCategorie} className="form-control" type="text" name="permisCategorie" id="permisCategorie" onChange={handleChange} />
            </div>
            <div className="col">
              <label htmlFor="autresPermis">Autres Compétance : </label>
              <input value={personnel.autresPermis} className="form-control" type="text" name="autresPermis" id="autresPermis" onChange={handleChange} />
            </div>
          </div>
        </fieldset>


        <div className="row">
          <div className="col-md-4">
            <label htmlFor="rupture">Etat de Service : </label>
            <select value={personnel.rupture} onChange={handleChange} name="rupture" id="rupture" className="form-control">
              <option value={personnel.rupture}>{personnel.rupture}</option>
              <option value="EN SERVICE">EN SERVICE</option>
              <option value="RETRAITE">RETRAITE</option>
              <option value="DECEDE">DECEDE</option>
              <option value="LICENCIEMENT">LICENCIEMENT</option>
              <option value="RESILIATION_CONTRAT">RESILIATION_CONTRAT</option>
            </select>
          </div>
          <div className="col-md-4">
            <label htmlFor="file">Image : </label>
            <input type="file" name="file" onChange={handleImageChange} accept="image/*" />
          </div>
          {personnel.filename && !removeImage && (
            <div
              style={{
                position: 'relative',
                display: 'inline-block',
                marginTop: '10px',
              }}
            >
              {personnel.filename ? <img src={`${baseUrl}/images/personnels/${personnel.filename}`} width="50px" height="50px" alt="" /> : <img src={`${baseUrl}/images/personnels/defaultImage.jpg`} width="50px" height="50px" alt="" style={{ width: '100px', height: '100px', objectFit: 'cover' }} />}
              <button
                type="button"
                onClick={handleRemoveImage}
                style={{
                  position: 'absolute',
                  top: '0',
                  right: '0',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '5px',
                  borderRadius: '50%',
                }}
              >
                <i className="fa fa-trash"></i> {/* Icône en forme de croix */}
              </button>
            </div>
          )}
        </div>

        <fieldset className="border border-warning custom-fieldset border-3 rounded" style={{ borderWidth: '5px' }} >
          <legend className="w-auto px-4 text-primary">
            INFORMATION MILITAIRE
          </legend>

          {/* CONTENEUR */}
          <div className="row mb-3 mx-3">

            <div className="col-12">

              {/* LIGNE 1 */}
              <div className="row">
                <div className="col">
                  <label>Matricule Finance :</label>
                  <input
                    value={personnel.MatriculeFinance}
                    className=" form-control"
                    type="text"
                    name="MatriculeFinance"
                    onChange={handleChange}
                  />
                </div>

                <div className="col">
                  <label>Spécialité :</label>
                  <select
                    value={personnel.diplomeadministratif}
                    onChange={handleChange}
                    name="diplomeadministratif"
                    className="form-control"
                  >
                    <option value=""></option>
                    <option value="TRESORIER">TRESORIER</option>
                    <option value="INFANTERIE">INFANTERIE</option>
                    <option value="CHANCELLERIE">CHANCELLERIE</option>
                    <option value="TRANSMISSION">TRANSMISSION</option>
                    <option value="INFORMATICIEN">INFORMATICIEN</option>
                    <option value="MECANICIEN">MECANICIEN</option>
                    <option value="ELECTRICIEN">ELECTRICIEN</option>
                    <option value="ADMINISTRATION">ADMINISTRATION</option>
                    <option value="MEDECIN">MEDECIN</option>
                  </select>
                </div>

                <div className="col">
                  <label>CIM :</label>
                  <input value={personnel.cim} id="cim" name='cim' onChange={handleChange} type='text' className="form-control" />
                </div>

                <div className="col">
                  <label>Campagne :</label>
                  <input value={personnel.campagne} className="form-control" id="campagne" name='campagne' onChange={handleChange} type='text' />
                </div>
              </div>

              {/* LIGNE 2 */}
              <div className="row mt-2">
                <div className="col">
                  <label>Punition :</label>
                  <input value={personnel.punition} id="punition" name='punition' onChange={handleChange} className="form-control" />
                </div>

                <div className="col">
                  <label>Affectation Temporaire :</label>
                  <input value={personnel.affectationTemporaire} id="affectationTemporaire" name='affectationTemporaire' onChange={handleChange} className="form-control" />
                </div>

                <div className="col">
                  <label>Affectation Définitive :</label>
                  <input value={personnel.affectationDedinitive} id="affectationDedinitive" name='affectationDedinitive' onChange={handleChange} className="form-control" />
                </div>

                <div className="col">
                  <label>Position exacte :</label>
                  <input value={personnel.positionexacte} id="positionexacte" name='positionexacte' onChange={handleChange} className="form-control" />
                </div>
              </div>

              {/* LIGNE 3 */}
              <div className="row mt-2">

                <div className="col">
                  <label>Élèves :</label>
                  <select value={personnel.eleves} id="eleves" name='eleves' onChange={handleChange} className="form-control">
                    <option value=""></option>
                    <option value="EOD">EOD</option>
                    <option value="ELD">ELD</option>
                    <option value="ECO">ECO</option>
                  </select>
                </div>

                <div className="col">
                  <label>Prénoms Usuel :</label>
                  <input value={personnel.prenomsUsuel} id="prenomsUsuel" name='prenomsUsuel' type="text" onChange={handleChange} className="form-control" />
                </div>

                <div className="col">
                  <label>Sortant d'école :</label>
                  <input value={personnel.sortantecole} id="sortantecole" name='sortantecole' type="text" onChange={handleChange} className="form-control" />
                </div>
              </div>

              {!personnel.matricule && (
                <div className="row mt-4">
                  <div className="col-md-6">
                    <fieldset className="border bg-light">
                      <legend className="w-auto px-2 fw-bold">PDL</legend>
                      <div className="row mb-3 mx-3">
                        <div className="col d-flex align-items-center">
                          <label htmlFor="annee" className="me-2 mb-0">Année :</label>
                          <select
                            id="annee"
                            name="annee"
                            value={personnel.annee}
                            onChange={handleChange}
                            className="form-control"
                            style={{ maxWidth: "120px" }} // ajuste la largeur du select
                          >
                            <option value=""></option>
                            <option value="2023">2023</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                            <option value="2027">2027</option>
                          </select>
                        </div>

                        <div className="col d-flex align-items-center">
                          <label htmlFor="vague" className="me-2 mb-0">Vague :</label>
                          <select
                            id="vague"
                            name="vague"
                            value={personnel.vague}
                            onChange={handleChange}
                            className="form-control"
                            style={{ maxWidth: "80px" }} // ajuste la largeur du select
                          >
                            <option value=""></option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                          </select>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              )}
            </div>
          </div>
        </fieldset>


        <hr />
        <div className="">
          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li className="nav-item">
              <a className="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-affectation" role="tab" aria-controls="pills-home" aria-selected="true">
                Affectations Succ.
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-enfant" role="tab" aria-controls="pills-profile" aria-selected="false">
                Enfants
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-ecole" role="tab" aria-controls="pills-contact" aria-selected="false">
                Ecoles/Stages
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-avancement" role="tab" aria-controls="pills-contact" aria-selected="false">
                Avancements
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-decoration" role="tab" aria-controls="pills-contact" aria-selected="false">
                Décorations
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-promotion" role="tab" aria-controls="pills-contact" aria-selected="false">
                Grade Succ.
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="pills-mouvement-tab" data-toggle="pill" href="#pills-mouvement" role="tab" aria-controls="pills-mouvement" aria-selected="false">
                Opération/Stagiaire/Détaché
              </a>
            </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active col" id="pills-affectation" role="tabpanel" aria-labelledby="pills-home-tab">
              <div className="row">
                <div className="col">
                  {affectations.map((affectation, index) => (
                    <div key={index}>
                      <div className="row">
                        <div className="col">
                          <label htmlFor="lieuaffect">Lieu Affect.</label>
                          <input
                            value={affectation.lieuaffect}
                            onChange={(e) => {
                              handleAddAffectationChange(index, e);
                            }}
                            type="text"
                            id="lieuaffect"
                            name="lieuaffect"
                            className="form-control"
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="fonctiontenue">Fonction tenue.</label>
                          <input
                            value={affectation.fonctiontenue}
                            onChange={(e) => {
                              handleAddAffectationChange(index, e);
                            }}
                            type="text"
                            id="fonctiontenue"
                            name="fonctiontenue"
                            className="form-control"
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="dateeffet">Date Effet.</label>
                          <input
                            value={affectation.dateeffet}
                            onChange={(e) => {
                              handleAddAffectationChange(index, e);
                            }}
                            type="date"
                            id="dateeffet"
                            name="dateeffet"
                            className="form-control"
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="decisionaffectation">Décision d'affectation.</label>
                          <input
                            value={affectation.decisionaffectation}
                            onChange={(e) => {
                              handleAddAffectationChange(index, e);
                            }}
                            type="text"
                            id="decisionaffectation"
                            name="decisionaffectation"
                            className="form-control"
                          />
                        </div>
                        <i onClick={() => handleRemoveAffectation(index)} className="fa fa-trash fa-1x "></i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="text-right row mt-2-right row mt-2">
                <div className="col">
                  <button className="btn btn-primary" type="button" onClick={handleAddAffectation}>
                    Ajout affectation
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-enfant" role="tabpanel" aria-labelledby="pills-profile-tab">
              <div className="row">
                <div className="col-md-12 ">
                  {enfants.map((enfant, index) => (
                    <div key={index}>
                      <div className="row">
                        <div className="col">
                          <label htmlFor="Nom et prénoms">Nom et prénoms.</label>
                          <input
                            value={enfant.nomprenom}
                            onChange={(e) => {
                              handleAddEnfantChange(index, e);
                            }}
                            type="text"
                            id="nomprenom"
                            name="nomprenom"
                            className="form-control"
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="Date de naissance">Date de naissance.</label>
                          <input
                            value={enfant.datenaisse}
                            onChange={(e) => {
                              handleAddEnfantChange(index, e);
                            }}
                            type="date"
                            id="datenaisse"
                            name="datenaisse"
                            className="form-control"
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="sexe">Sexe..</label>
                          <select
                            value={enfant.sexe}
                            onChange={(e) => {
                              handleAddEnfantChange(index, e);
                            }}
                            className="form-control"
                            id="sexe"
                            name="sexe"
                          >
                            <option value=""></option>
                            <option value="1">H</option>
                            <option value="2">F</option>
                          </select>
                        </div>
                        <div className="col">
                          <label htmlFor="observation">Observation.</label>
                          <select
                            value={enfant.observation}
                            onChange={(e) => {
                              handleAddEnfantChange(index, e);
                            }}
                            id="observation"
                            name="observation"
                            className="form-control"
                          >
                            <option value=""></option>
                            <option value="LEGITIME">LEGITIME</option>
                            <option value="RECONUE">RECONUE</option>
                            <option value="ADOPTE">ADOPTE</option>
                          </select>
                        </div>
                        <i onClick={() => handleRemoveEnfant(index)} className="fa fa-trash fa-1x "></i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="text-right row mt-2-left row mt-2">
                <div className="col-md-12">
                  <button className="btn btn-primary" type="button" onClick={handleAddEnfant}>
                    Ajout Enfant
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-ecole" role="tabpanel" aria-labelledby="pills-contact-tab">
              <div className="col">
                {ecole.map((ecole, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label htmlFor="intitule">Intitulé.</label>
                        <input
                          value={ecole.intitule}
                          onChange={(e) => {
                            handleAddEcoleChange(index, e);
                          }}
                          type="text"
                          id="intitule"
                          name="intitule"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="etablissement">Etablissement.</label>
                        <input
                          value={ecole.etablissement}
                          onChange={(e) => {
                            handleAddEcoleChange(index, e);
                          }}
                          type="text"
                          id="etablissement"
                          name="etablissement"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="diplome">Diplôme.</label>
                        <input
                          value={ecole.diplome}
                          onChange={(e) => {
                            handleAddEcoleChange(index, e);
                          }}
                          type="text"
                          id="diplome"
                          name="diplome"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="annee">Année.</label>
                        <input
                          value={ecole.annee}
                          onChange={(e) => {
                            handleAddEcoleChange(index, e);
                          }}
                          type="text"
                          id="annee"
                          name="annee"
                          className="form-control"
                        />
                      </div>
                      <i onClick={() => handleRemoveEcole(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="text-right row mt-2">
                <div className=" col mt-3">
                  <button className="btn btn-primary" type="button" onClick={handleAddEcole}>
                    Ajout Ecole
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-avancement" role="tabpanel" aria-labelledby="pills-contact-tab">
              <div className="col">
                {avancements.map((avancement, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label htmlFor="statu">Statu.</label>
                        <input
                          value={avancement.statu}
                          onChange={(e) => {
                            handleAddAvancementChange(index, e);
                          }}
                          type="text"
                          id="statu"
                          name="statu"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="reference">Référence.</label>
                        <input
                          value={avancement.reference}
                          onChange={(e) => {
                            handleAddAvancementChange(index, e);
                          }}
                          type="text"
                          id="reference"
                          name="reference"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="dateeffet">Date Effet.</label>
                        <input
                          value={avancement.dateeffet}
                          onChange={(e) => {
                            handleAddAvancementChange(index, e);
                          }}
                          type="date"
                          id="dateeffet"
                          name="dateeffet"
                          className="form-control"
                        />
                      </div>
                      <i onClick={() => handleRemoveAvancement(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row">
                <div className=" col text-right mt-3 ">
                  <button className="btn btn-primary" type="button" onClick={handleAddAvancement}>
                    Ajout Avancement
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-decoration" role="tabpanel" aria-labelledby="pills-contact-tab">
              <div className="col">
                {listeDecoration.map((decoration, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label htmlFor="decretouarrete">Décret ou Arrete.</label>
                        <input
                          value={decoration.decretouarrete}
                          onChange={(e) => {
                            handleAddDecorationChange(index, e);
                          }}
                          type="text"
                          id="decretouarrete"
                          name="decretouarrete"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="dateObtention">Date.</label>
                        <input
                          value={decoration.dateObtention}
                          onChange={(e) => {
                            handleAddDecorationChange(index, e);
                          }}
                          type="date"
                          id="dateObtention"
                          name="dateObtention"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor={`decoration-id-${index}`}>Décoration :</label>
                        <select id={`decoration-id-${index}`} value={decoration.decorationId} onChange={(e) => handleAddDecorationChange(index, e)} className="form-control" name="decorationId">
                          {/* multiple="multiple" */}
                          <option value="">Séléctionnez le décoration</option>
                          {decorations.map((decoration, key) => {
                            return (
                              <option key={key} value={decoration.id}>
                                {decoration.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <i onClick={() => handleRemoveDecoration(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row">
                <div className="col text-right">
                  <button className="btn btn-primary" type="button" onClick={handleAddDecoration}>
                    Ajout Décoration
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-promotion" role="tabpanel" aria-labelledby="pills-promotion-tab">
              <div className="col">
                {promotiongrade.map((promotiongrade, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label htmlFor="datepromotion">Date de promotion :</label>
                        <input
                          value={promotiongrade.datepromotion}
                          onChange={(e) => {
                            handleAddPromotionGradeChange(index, e);
                          }}
                          type="date"
                          id="datepromotion"
                          name="datepromotion"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="portgrade">Port de grade :</label>
                        <input
                          value={promotiongrade.portgrade}
                          onChange={(e) => {
                            handleAddPromotionGradeChange(index, e);
                          }}
                          type="text"
                          id="portgrade"
                          name="portgrade"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="grade">Grade : </label>
                        <select
                          value={promotiongrade.gradeId}
                          onChange={(e) => {
                            handleAddPromotionGradeChange(index, e);
                          }}
                          id="gradeId"
                          name="gradeId"
                          className="form-control"
                          required
                        >
                          <option value=""></option>
                          {listGrade.map((grade, key) => {
                            return (
                              <option key={key} value={grade.id}>
                                {grade.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <i onClick={() => handleRemovePromotionGrade(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>
              <div className="row">
                <div className=" col text-right">
                  <button className="btn btn-primary mt-4 " type="button" onClick={handleAddPromotionGrade}>
                    Ajout Promotion Grade
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-pane fade col" id="pills-mouvement" role="tabpanel" aria-labelledby="pills-mouvement-tab">
              <div className="col">
                {operations.map((operation, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col">
                        <label>Lieu :</label>
                        <select className="form-control" name="boadssId" value={operation.boadssId} onChange={(e) => handleAddOperationChange(index, e)}>
                          <option value="">Sélectionner BOA ou DSS</option>
                          {boaDss.map((boadss) => (
                            <option key={boadss.id} value={boadss.id}>
                              {boadss.bataillonoudss}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col">
                        <label htmlFor="observation">Situation :</label>
                        <select
                          value={operation.observation}
                          onChange={(e) => {
                            handleAddOperationChange(index, e);
                          }}
                          id="observation"
                          name="observation"
                          className="form-control"
                        >
                          <option value=""></option>
                          <option value="MISSION">MILITAIRE EN OPERATIONS</option>
                          <option value="DETACHE">MILITAIRES DETACHES</option>
                          <option value="STAGEINTERNE">STAGIAIRES INTERIEUR</option>
                          <option value="STAGEEXTERNE">STAGIAIRES EXTERIEUR</option>
                        </select>
                      </div>
                      <div className="col">
                        <label htmlFor="dateDebut">Date début :</label>
                        <input
                          value={operation.dateDebut}
                          onChange={(e) => {
                            handleAddOperationChange(index, e);
                          }}
                          type="date"
                          name="dateDebut"
                          id="dateDebut"
                          className="form-control"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="dateFin">Date fin :</label>
                        <input
                          value={operation.dateFin}
                          onChange={(e) => {
                            handleAddOperationChange(index, e);
                          }}
                          type="date"
                          name="dateFin"
                          id="dateFin"
                          className="form-control"
                        />
                      </div>
                      <i onClick={() => handleRemoveOperation(index)} className="fa fa-trash fa-1x "></i>
                    </div>
                  </div>
                ))}
              </div>
              <div className="row">
                <div className=" col text-right mt-3 ">
                  <button className="btn btn-primary mt-4 " type="button" onClick={handleAddOperation}>
                    Ajout Opération
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-3 d-flex justify-content-start">
          <div className='col-md-6'>
            <div className="col d-flex align-items-center">
              <label htmlFor="affectionactuelle" className="me-2 mb-0">Vérification :</label>
              <select
                id="affectionactuelle"
                name="affectionactuelle"
                value={personnel.affectionactuelle}
                onChange={handleChange}
                className="form-control "
                style={{ maxWidth: "150px" }}
              >
                <option value=""></option>
                <option value="VERIFIER">VERIFIER</option>
              </select>
            </div>
            <br />
            <div className="col d-flex align-items-center">
              <label htmlFor="valider" className="me-2 mb-0 mr-1">Valider l'enregistrement ?</label>
              <input
                type="checkbox"
                name="valider"
                id="valider"
                checked={personnel.valider}
                onChange={handleChange}
                ref={checkboxRef}
                style={{ transform: 'scale(1.6)', cursor: 'pointer' }}
                className="me-2 mr-3"
              />
              {personnel.valider && <span>J'accepte cet enregistrement</span>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            {message && <p style={{ color: 'green' }}>{message}</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </div>
        </div>

        <div className="row">
          <div className="col">
            <button type="submit" className="btn btn-success mt-4">
              Enregistrer
            </button>
          </div>
        </div>
        {/* <span className='col-md-6'> {JSON.stringify(personnel)} </span> */}
      </form >
    </div >
  );
};

export default EditPersonnel;
